import { DefaultValue } from "recoil";
import { api } from "@/comn";
import { comnEnvs, comnUtils } from "@/comn/utils";
import { lpcoEnvs } from "@/tz/go/egaz/osci/lpco/comn"; // 시스템 공통 유틸
import { TFormSchema, TGridSchema } from "@/comn/hooks";

export const BASE = {
    path: `${lpcoEnvs.base}/lpco/hscd/ctgr`,
    api: `${process.env.REACT_APP_API_OSCI}/api/v1/osci/lpco/hscd/ctgr`,
    nodes: [
        // TODO 라벨 처리 필요
        { path: "/", label: "L_ESW" },
        { path: "/lpco/hscd/ctgr", label: "L_HS_CD" },
        { path: "/lpco/hscd/ctgr", label: "L_RGSR" },
    ],
};

export const URLS = {
    osci0204005s: `${BASE.path}/osci0204005s`,
    osci0204006q: `${BASE.path}/osci0204006q`,
    osci0204007s: `${BASE.path}/osci0204007s`,
    osci0204008s: `${BASE.path}/osci0204008s`,
};
export const APIS = {
    getHsCtgrItmList: (data: any) => {
        console.log("getHsCtgrItmList data :: ", data);
        return api.get(`${BASE.api}/itm`, { params: comnUtils.toGetParams(data) });
    },
    saveHsCtgrItmList: (data: any) => {
        return api.put(`${BASE.api}`, {
            ...data,
        });
    },
    getHsCtgrItmInfo: (hsCtgrId: any) => {
        return api.get(`${BASE.api}/${hsCtgrId}`, {});
    },
    getHsCtgrList: (data: any, page: number, size: number) => {
        return api.get(`${BASE.api}?page=${page}&size=${size}`, {
            params: comnUtils.toGetParams(data),
        });
    },
    getHsCtgrItmValdn: (data: any) => {
        return api.post(`${BASE.api}/itm-valdn`, {
            ...data,
        });
    },
    saveHsCtgrItm: (hsCtgrId: any, data: any) => {
        return api.put(`${BASE.api}/${hsCtgrId}`, {
            ...data,
        });
    },
    deleteHsCtgrItm: (hsCtgrId: any) => {
        return api.delete(`${BASE.api}/${hsCtgrId}`, {});
    },
};

export const SF_HS_CTGR: TFormSchema = {
    id: "form_hsCtgr",
    schema: {
        orgCd: {
            type: "text",
            label: "L_OGA",
            edit: false,
        } /* OGA !== OGA ==!*/,
        orgNm: {
            type: "text",
            label: "L_OGA",
            edit: false,
        } /* OGA !== OGA ==!*/,
        prcssitmCtgrTpCd: {
            type: "select",
            label: "L_ITM_CTGR",
            area: "comnCd",
            comnCd: "OSC0130",
            all: true,
        },
        srchItmCtgrTpCd: {
            type: "select",
            label: "L_ITM_CTGR",
            area: "comnCd",
            comnCd: "OSC0130",
            all: true,
        },
    },
};

export const SG_HS_CODE_LIST: TGridSchema = {
    id: "grid_rgsrHscodeList",
    options: {
        pagination: false,
        edit: true,
        checkbox: true,
        radio: false,
        index: true,
        height: 500,
        importExcel: true,
    },
    head: [
        { cells: [{ header: "L_ITM_CTGR", binding: "itmCtgrTpCd", width: 150 }] },
        { cells: [{ header: "L_HS_CD", binding: "hsCd", width: 350 }] },
        { cells: [{ header: "L_RMRK", binding: "rmrk", width: "*" }] },
        { cells: [{ header: "L_VLD_STRT_DT", binding: "appdStrtDt", width: 150 }] },
        { cells: [{ header: "L_VLD_END_DT", binding: "appdEndDt", width: 150 }] },
    ],
    body: [
        {
            cells: [
                {
                    binding: "itmCtgrTpCd",
                    type: "select",
                    area: "comnCd",
                    comnCd: "OSC0130",
                    required: true,
                    excel: "A",
                },
            ],
        },
        {
            cells: [
                { binding: "hsCd", type: "code", area: "hsCd", required: true, excel: "B" },
            ] /* Hs code !== Hs 코드 ==!*/,
        },
        {
            cells: [{ binding: "rmrk", maxLength: 2000, excel: "C" }],
        },
        {
            cells: [
                { binding: "appdStrtDt", type: "date", required: true, excel: "D" },
            ] /**  Valid Start Date !== 유효_시작_일자 ==! */,
        },
        {
            cells: [
                { binding: "appdEndDt", type: "date", required: true, excel: "E" },
            ] /**  Valid End Date !== 유효_종료_일자 ==! */,
        },
    ],
};

export const SF_SRCH_HS_CTGR: TFormSchema = {
    id: "form_srchHsCtgr",
    schema: {
        orgCd: {
            type: "text",
            label: "L_OGA",
            edit: false,
        } /* OGA !== OGA ==!*/,
        orgNm: {
            type: "text",
            label: "L_OGA",
            edit: false,
        } /* OGA !== OGA ==!*/,
        srchItmCtgrTpCd: {
            type: "select",
            label: "L_ITM_CTGR",
            area: "comnCd",
            comnCd: "OSC0130",
            all: true,
        },
        srchHsCd: {
            type: "code",
            area: "hsCd",
            label: "L_HS_CD",
        },
        srchRmrk: {
            type: "text",
            label: "L_RMRK",
        },
        srchAppdDt: {
            type: "daterange",
            label: "L_VLD_DT",
            start: { name: "srchAppdStrtDt" },
            end: { name: "srchAppdEndDt" },
        },
    },
};

export const SG_HS_CTGR_LIST: TGridSchema = {
    id: "grid_hsCtgrList",
    options: { pagination: "out", edit: false, checkbox: false, radio: false, index: true, height: 500 },
    head: [
        { cells: [{ header: "L_ITM_CTGR", binding: "itmCtgrTpCd", width: 150 }] },
        { cells: [{ header: "L_HS_CD", binding: "hsCd", width: 550 }] },
        { cells: [{ header: "L_RMRK", binding: "rmrk", width: "*" }] },
        { cells: [{ header: "L_VLD_STRT_DT", binding: "appdStrtDt", width: 120 }] },
        { cells: [{ header: "L_VLD_END_DT", binding: "appdEndDt", width: 120 }] },
    ],
    body: [
        {
            cells: [
                {
                    binding: "itmCtgrTpCd",
                    type: "select",
                    area: "comnCd",
                    comnCd: "OSC0130",
                    align: "left",
                    viewType: "label",
                },
            ],
        },
        {
            cells: [{ binding: "hsCd", type: "code", area: "hsCd", align: "left" }] /* Hs code !== Hs 코드 ==!*/,
        },
        {
            cells: [{ binding: "rmrk", align: "left" }],
        },
        {
            cells: [{ binding: "appdStrtDt", type: "date" }],
        },
        {
            cells: [{ binding: "appdEndDt", type: "date" }],
        },
    ],
};

export const SF_HS_CTGR_ITM_U: TFormSchema = {
    id: "form_srchHsCtgrItmU",
    schema: {
        orgCd: {
            type: "text",
            label: "L_OGA",
            edit: false,
        } /* OGA !== OGA ==!*/,
        orgNm: {
            type: "text",
            label: "L_OGA",
            edit: false,
        } /* OGA !== OGA ==!*/,
        itmCtgrTpCd: {
            label: "L_ITM_CTGR",
            type: "select",
            area: "comnCd",
            comnCd: "OSC0130",
            required: true,
            viewType: "label",
        },
        hsCd: {
            label: "L_HS_CD",
            type: "code",
            area: "hsCd",
            required: true,
        },
        rmrk: {
            type: "text",
            label: "L_RMRK",
            maxLength: 2000,
        },
        appdStrtDt: {
            type: "date",
            label: "L_VLD_STRT_DT",
            required: true,
        },
        appdEndDt: {
            type: "date",
            label: "L_VLD_END_DT",
            required: true,
        },
    },
};
